import './ContactInfo.scss';

function ContactInfo({
    img,
    title,
    subtitle,
    link
}: {
    img: React.JSX.Element,
    title: string,
    subtitle: string,
    link: string | null
}) {
    return (
        <div className="contact">
            {img}
            <div>
                <h4>{title}</h4>
                {link && <a href={link}><span className="contact__subtitle">{subtitle}</span></a>}
                {!link && <span className="contact__subtitle">{subtitle}</span>}
            </div>
        </div>
    );
}

export default ContactInfo;